import React, { useEffect, useState } from 'react';
import { Button, Form, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Grid } from '../../../models';
import { useForm } from 'antd/lib/form/Form';

// CUSTOM DEVELOPMENT
export function ItemJigNewRecordPage(props: { grid?: Grid; onSaved: () => void }) {
  const [form] = useForm();

  const [loading, setLoading] = useState(false);
  const [optionsLoading, setOptionsLoading] = useState(false);
  const [itemOptions, setItemOptions] = useState<any[]>();
  const [jigOptions, setJigOptions] = useState<any[]>();

  useEffect(() => {
    loadOptions();
  }, []);

  const loadOptions = () => {
    setOptionsLoading(true);
    apiClient
      .get('records/custom/item-jig-options')
      .then(response => {
        const responseOptions: any = response.data;
        setItemOptions(responseOptions.items);
        setJigOptions(responseOptions.jigs);
        setOptionsLoading(false);
      })
      .catch((reason: any) => {
        setOptionsLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onFinish = (values: any) => {
    setLoading(true);
    apiClient
      .post(`records/custom/item-jigs`, values)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form form={form} layout="vertical" name="basic" onFinish={onFinish}>
      <Form.Item label="Kalem" name="item" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select
          loading={optionsLoading}
          showSearch
          filterOption={(input, option) => {
            if (!option?.children) {
              return false;
            }
            return option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        >
          {itemOptions?.map(r => (
            <Select.Option key={r.MDM_ID} value={r.MDM_ID}>
              {r.ITEM_NAME + ' - ' + r.STOK_NO + ' - ' + r.REVISION}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Mastarlar" name="jigs" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select
          loading={optionsLoading}
          mode="multiple"
          showSearch
          filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {jigOptions?.map(r => (
            <Select.Option key={r.MDM_ID} value={r.MDM_ID}>
              {r.MASTAR_STANDARD_TANIM}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
